<template>
  <div class="button-group">
    <app-button @onclick="exportFile()">
      Export to File
      <tooltip :text="TOOLTIP_TEXT.EXPORT_FILE"></tooltip>
    </app-button>
    <app-button @onclick="copy()">
      Copy to Clipboard
      <tooltip :text="TOOLTIP_TEXT.COPY_TO_CLIPBOARD"></tooltip>
    </app-button>
  </div>
</template>

<script>
import AppButton from "./AppButton.vue";
import Tooltip from "./Tooltip.vue";
import { TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { Bus } from "../main.js";

export default {
  name: "ButtonGroup",
  components: {
    "app-button": AppButton,
    "tooltip": Tooltip,
  },
  data() {
    return {
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    }
  },
  methods: {
    exportFile: function () {
      this.$emit("export");
    },
    copy: function () {
      this.$emit("copy");
    },
  },
};
</script>

<style scoped>
.button-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>